"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectClassic = exports.SelectClassicField = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var nameFieldsBuilder_1 = require("../../../nameFieldsBuilder");
var fieldMaker_1 = require("../../fieldMaker");
require("./selectClassic.css");
var SelectClassicField = /** @class */ (function (_super) {
    __extends(SelectClassicField, _super);
    function SelectClassicField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectRef = React.createRef();
        _this.onChangeSelectClassic = function (e) {
            return _this.props.onChange && _this.props.onChange(e.target.value, _this.findData(e.target.value));
        };
        return _this;
    }
    SelectClassicField.prototype.findData = function (value) {
        return (0, function_1.pipe)(O.fromNullable(this.props.options), O.filter(function (os) { return os.length > 0; }), O.map(function (os) { return os.filter(function (o) { return o.value === value; }); }), O.chainNullableK(function (os) { return os[0]; }), O.getOrElse(function () { return ({ label: '', value: value }); }));
    };
    SelectClassicField.prototype.componentDidUpdate = function () {
        var _this = this;
        (0, function_1.pipe)(O.fromNullable(this.selectRef.current), O.filter(function (_) { return typeof _this.props.value === 'undefined'; }), O.map(function (r) { return (r.selectedIndex = _this.props.labelOptions ? 0 : -1); }));
    };
    SelectClassicField.prototype.decorateOptions = function () {
        var _this = this;
        if (!this.props.labelOptions) {
            return this.props.options || [];
        }
        return (0, function_1.pipe)(O.fromNullable(this.props.options), O.map(function (os) { return (os.length === 1 ? os : __spreadArray([{ value: '', label: "".concat(_this.props.labelOptions, "...") }], os, true)); }), O.getOrElse(function () { return [
            {
                value: '',
                label: "".concat(_this.props.labelOptions, "..."),
            },
        ]; }));
    };
    SelectClassicField.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)("span", __assign({ className: (0, clsx_1.default)('select-classic', { disabled: this.props.disabled ? true : false }, this.props.className) }, { children: (0, jsx_runtime_1.jsx)("select", __assign({ name: (0, nameFieldsBuilder_1.buildFieldName)(this.props.name), disabled: this.props.disabled, onChange: this.onChangeSelectClassic, value: this.props.value || undefined, ref: this.selectRef }, { children: this.decorateOptions().map(function (option, index) { return ((0, jsx_runtime_1.jsx)("option", __assign({ value: option.value, disabled: option.disabled }, { children: option.label }), index)); }) })) })));
    };
    return SelectClassicField;
}(React.PureComponent));
exports.SelectClassicField = SelectClassicField;
exports.SelectClassic = (0, fieldMaker_1.makeField)(SelectClassicField);
//# sourceMappingURL=SelectClassic.js.map